module.exports = __webpack_public_path__ + "img/zzjg.727af7be.png";